<mat-form-field class="full-width">
  @if (label) {
  <mat-label>{{label}}</mat-label>
  }
  @if (isMultiple) {
  <mat-select msInfiniteScroll (infiniteScroll)="getNextBatch()" [formControl]="ctrl" [ngModel]="preSelectedValues" multiple>
    <mat-option>
      <ngx-mat-select-search [formControl]="searchCtrl" placeholderLabel="search"
        noEntriesFoundLabel="No entry matches">
      </ngx-mat-select-search>
    </mat-option>
    @for (item of list; track item) {
    <mat-option [value]=" isFlatArray? item: item[valueKey]">
      <span> {{ isFlatArray? item: item[displayKey] }}</span>
    </mat-option>
    }
  </mat-select>
  } @else {
  <mat-select msInfiniteScroll (infiniteScroll)="getNextBatch()" [formControl]="ctrl">
    <mat-option>
      <ngx-mat-select-search [formControl]="searchCtrl" placeholderLabel="search"
        noEntriesFoundLabel="No entry matches">
      </ngx-mat-select-search>
    </mat-option>
    @for (item of list; track item) {
    <mat-option [value]=" isFlatArray? item: item[valueKey]">
      <span> {{ isFlatArray? item: item[displayKey] }}</span>
    </mat-option>
    }
  </mat-select>
  }
  @if (hideRefreshBtn === false) {
  <i class="fa fa-refresh refreshbtn loader" matSuffix (click)="refresh(); $event.stopPropagation()"
    [ngClass]="{'fa-spin': loading }">
  </i>
  }
  @if (hint) {
  <mat-hint [style]="hintStyle" style="color: #777;">{{hint}}</mat-hint>
  }
</mat-form-field>